"use client";
import { jsxs as f, jsx as a } from "react/jsx-runtime";
import { cva as m } from "class-variance-authority";
import { useId as p } from "react";
import { SelectRoot as b, SelectTrigger as x, SelectValue as k, SelectIcon as v } from "../../atoms/Select/Select.mjs";
import { cn as o } from "../../../utils/utils.mjs";
const g = m(
  "flex items-center border font-semibold text-base [&_[data-slot=select-value]_span]:font-semibold dark:bg-neutral-dark-100 dark:text-neutral-dark-1000 dark:border-transparent dark:hover:not-disabled:border-neutral-dark-600 dark:disabled:text-neutral-dark-600",
  {
    variants: {
      variant: {
        default: "h-14 min-w-32 w-fit rounded-full p-4 gap-4",
        "icon-only": "h-10 w-11 rounded-3xl px-2 py-4 gap-1"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), N = ({
  className: d,
  children: n,
  variant: r = "default",
  icon: t,
  placeholder: l,
  selectTriggerProps: s,
  selectValueProps: c,
  ...u
}) => {
  const e = r === "icon-only", i = p();
  return /* @__PURE__ */ f(b, { ...u, children: [
    /* @__PURE__ */ a(
      x,
      {
        "aria-labelledby": e ? void 0 : i,
        "aria-label": e ? l : void 0,
        iconPrefix: t ? /* @__PURE__ */ a("span", { className: "[&_path]:fill-white", children: t }) : void 0,
        iconSuffix: /* @__PURE__ */ a(v, { className: o(e ? "size-2" : "size-4") }),
        className: o(g({ variant: r }), d),
        ...s,
        children: !e && /* @__PURE__ */ a(k, { id: i, placeholder: l, ...c })
      }
    ),
    n
  ] });
};
export {
  N as MediaSelect
};
